<template>
  <div class>
    <!-- <div class="col-12">
              <div class="row">
                <div class="col-md-6 mb-4">
                  <div class="d-flex align-items-center">
                    <b-dropdown
                      text="Country"
                      variant="dropdown-curve-lg bg-theme-light"
                      class="w-100"
                    >
                      <b-dropdown-item href="#">Action</b-dropdown-item>
                      <b-dropdown-item href="#">Another action</b-dropdown-item>
                      <b-dropdown-item
                        href="#"
                        v-for="(loop , key) in 20"
                        :key="key"
                      >Something else here</b-dropdown-item>
                    </b-dropdown>
                    <Tooltip :title="`Lists the only previously selected country. Now select the country to set the price configuration.`" />
                  </div>
                  <p class="error_msg">Invalid Entry</p>
                </div>
                <div class="col-md-6 mb-4">
                  <div class="d-flex align-items-center">
                    <b-dropdown
                      text="Currency"
                      variant="dropdown-curve-lg bg-theme-light"
                      class="w-100"
                    >
                      <b-dropdown-item href="#">Action</b-dropdown-item>
                      <b-dropdown-item href="#">Another action</b-dropdown-item>
                      <b-dropdown-item
                        href="#"
                        v-for="(loop , key) in 20"
                        :key="key"
                      >Something else here</b-dropdown-item>
                    </b-dropdown>
                    <Tooltip :title="`Currency to set the price configuration.`" />
                  </div>
                  <p class="error_msg">Invalid Entry</p>
                </div>
              </div>
    </div>-->
    <div class="jm-white-container mb-5">
      <div class="col-lg-11 mx-auto">
        <div class="row">
          <div v-if="cinemas.length > 1" class="col-md-6 mb-4">
            <div class="d-flex align-items-center">
              <b-dropdown
                :text="selectedCinema.label"
                variant="dropdown-curve-lg bg-theme-light"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(cinema,cinemaIndex) in cinemas"
                  :key="cinemaIndex"
                  @click="onSelectHandler(cinema)"
                >{{ cinema.cine_name }}</b-dropdown-item>
              </b-dropdown>
              <Tooltip :title="`Select Your Cinema`"  />
            </div>
            <!-- <p class="error_msg">Invalid Entry</p> -->
          </div>
          <div v-for="(item, index) in currencyValueList" :key="index" class="col-12 mb-4">
            <div class="row">
              <div class="col-md-3">
                <div class="d-flex align-items-center">
                  <div class="input-material w-100">
                    <input v-model="item.name" type="text" :id="'name'+index" placeholder="" />
                    <label :for="'name'+index">Name</label>
                  </div>
                  <Tooltip :title="`The amount or the percentage that will be applicable for the selected Key eg: 18% of VAT, 200AED of Entertainment tax is chargable to the total amount.`"  />
                </div>
                <!-- <p class="error_msg">Invalid Entry</p> -->
              </div>

              <div class="col-md-3">
                <div class="d-flex align-items-center">
                  <div class="input-material w-100">
                    <input v-model="item.key" type="text" :id="'key'+index" placeholder="" />
                    <label :for="'key'+index">Key</label>
                  </div>
                  <Tooltip :title="`The amount or the percentage that will be applicable for the selected Key eg: 18% of VAT, 200AED of Entertainment tax is chargable to the total amount.`"  />
                </div>
                <!-- <p class="error_msg">Invalid Entry</p> -->
              </div>

              <div class="col-md-3">
                <div class="d-flex align-items-center">
                  <div class="input-material w-100">
                    <input v-model="item.value" type="text" :id="'value'+index" placeholder="" />
                    <label :for="'value'+index">Value</label>
                  </div>
                  <Tooltip :title="`The amount or the percentage that will be applicable for the selected Key eg: 18% of VAT, 200AED of Entertainment tax is chargable to the total amount.`"  />
                </div>
                <!-- <p class="error_msg">Invalid Entry</p> -->
              </div>

              <div class="col-md-2 text-center">
                <div>Percentage?</div>
                <label class="ios-switch">
                  <input
                    :checked="item.percentage"
                    v-on:change="onChangeStatus(index,item.percentage)"
                    type="checkbox"
                    class="ios-checkbox"
                  />
                  <span class="switch-slider"></span>
                </label>
                <Tooltip :title="`The value entered is charged in amount or is percentage. If percentage is active then the value will be percentage, if not it will be charged in the amount. eg: VAT is 18% of total amount`"  />
              </div>

              <div class="col-1 d-flex align-items-center justify-content-center">
                <button v-if="index === 0" @click="increase()" class="btn-transparent">
                  <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
                </button>
                <button v-else @click="decrease(index)" class="btn-transparent">
                  <img src="@/assets/img/icons/minus.svg" height="35" width="35" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- 
        <ol class="d-flex" style="list-style:none">
          <li
            class="px-5"
            :style="{color:  current_cinema_index == noc ? 'green':''}"
            v-for="(noc,nocKey) in parseInt(noOfCinemas)"
            :key="nocKey"
          >{{ noc }}</li>
        </ol>-->

        <div class="col-md-12 mt-5 text-center">
          <router-link to="cinema-configuration" class="btn-outline-blue-lg w-25">Back</router-link>
          <router-link v-if="isUpdate" to="add-screens" class="btn-blue-lg w-25">Next</router-link>
          <router-link to v-on:click.native="onSubmit()" class="btn-blue-lg w-25">{{ BtnText }}</router-link>
          <router-link
            v-if="current_cinema_index > 1 && parseInt(noOfCinemas) > 1"
            to="add-screens"
            class="btn-blue-lg w-25"
          >Skip</router-link>
          <!-- v-on:click.native="onSubmit()" -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import SetupService from "@/services/SetupService";
import saveState from "vue-save-state";

export default {
  name: "Finance Configuration",
  mixins: [saveState],
  data() {
    return {
      BtnText: "Add Screens",
      isUpdate: false,
      selectedCinema: {
        label: "Select Cinema"
      },
      name: "",
      current_cinema_index: 1,
      financeConfiguration: [
        {
          currency: "AED",
          currencyValueList: [{}]
        }
      ],
      currencyValueList: [
        {
          name: "",
          key: "",
          value: "",
          percentage: false,
          cinema_id: window.localStorage.getItem("CURRENT_CINEMA_ID") || 1
        }
      ]
    };
  },
  components: {},
  computed: {
    noOfCinemas() {
      return this.$store.getters.NO_OF_CINEMAS || 1;
    },
    cinemas() {
      return this.$store.getters.CINEMAS;
    }
  },
  watch: {},
  beforeMount() {},
  mounted() {
    // this.increase();
    this.getList();
  },
  methods: {
    getSaveStateConfig() {
      return {
        cacheKey: "Finance Configuration"
      };
    },
    onChangeStatus: function(index, value) {
      this.currencyValueList[index].percentage = !value;
    },
    handleSubmit: function() {
      console.log("here :");
      this.$validator.validateAll().then(result => {
        if (result) {
          // eslint-disable-next-line
          alert("Form Submitted!");
          return;
        } else {
          console.log("else :");
        }
      });
    },
    getList: function() {
      let payload = {
        ID: 1
      };

      // MasterService.GetData(payload)
      //   .then(response => {
      //     console.log("object :", response);
      //     const { data } = response;
      //     this.currencyValueList = data.data;
      //   })
      //   .catch(error => {
      //     console.log("error :", error);
      //   });
    },
    ResetForm: function() {
      this.currencyValueList = [
        { name: "", key: "", value: "", percentage: false }
      ];
    },
    onSubmit: function() {
      let payload = {
        charge_types: this.currencyValueList
      };
      SetupService.AddFinance(payload)
        .then(result => {
          const { data } = result;
          if (data.status) {
            this.BtnText = "Update";
            this.isUpdate = true;
            // if (
            //   this.current_cinema_index == this.$store.getters.NO_OF_CINEMAS
            // ) {
            this.$router.push({
              path: "add-screens"
              // path: "add-cinema-master"
            });
            // } else {
            //   this.ResetForm();
            //   this.current_cinema_index++;
            // }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(err => {
          this.$toasted.show(err);
        });
    },
    increase: function() {
      this.currencyValueList.push({
        name: "",
        key: "",
        value: "",
        percentage: false,
        cinema_id: window.localStorage.getItem("CURRENT_CINEMA_ID") || 1
      });
    },
    decrease: function(index) {
      this.currencyValueList.splice(index, 1);
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Installation/financeConfiguration.vue